import React from 'react';
export function AuthorSection() {
  return <section className="py-14 md:py-20 bg-negro-medio" data-id="element-24">
      <div className="container" data-id="element-25">
        <div className="grid grid-cols-[280px_1fr] gap-10 md:gap-14 items-center max-md:grid-cols-1" data-id="element-26">
          <div className="relative max-md:max-w-[200px] max-md:mx-auto" data-id="element-27">
            <img src="https://cdn.magicpatterns.com/uploads/c8ozpYBePg16AKviVqT81N/IA4.png" alt="Lucas Sterling" className="w-full rounded grayscale-[20%]" data-id="element-28" />
            <div className="absolute -inset-2 border border-[rgba(201,151,43,.3)] rounded-lg pointer-events-none" data-id="element-29" />
          </div>
          <div data-id="element-30">
            <div className="section-label max-md:justify-center" data-id="element-31">El autor</div>
            <h2 className="font-playfair text-[2rem] text-blanco mb-1.5 max-md:text-center" data-id="element-32">
              Lucas Sterling
            </h2>
            <p className="font-cormorant italic text-[1.05rem] text-dorado-claro mb-[22px] max-md:text-center" data-id="element-33">
              Psicólogo social · Experto en dinámicas de poder y persuasión
            </p>
            <p className="text-crema-oscuro leading-[1.8] mb-4 text-[.92rem]" data-id="element-34">
              Durante más de 15 años, Lucas ha investigado cómo los principios
              de la psicología oscura pueden aplicarse de forma responsable —
              para influir con mayor impacto y protegerse de quienes los usan
              sin escrúpulos.
            </p>
            <p className="text-crema-oscuro leading-[1.8] mb-4 text-[.92rem]" data-id="element-35">
              Su enfoque combina rigor académico con aplicación práctica
              inmediata: sin jerga innecesaria, sin promesas vacías. Solo
              herramientas que funcionan.
            </p>
            <div className="flex gap-7 mt-6 flex-wrap max-md:justify-center max-sm:gap-[18px]" data-id="element-36">
              <div data-id="element-37">
                <strong className="block font-playfair text-[1.7rem] text-dorado-claro" data-id="element-38">
                  +4.000
                </strong>
                <span className="text-[.77rem] text-gris-texto uppercase tracking-[.08em]" data-id="element-39">
                  Lectores globales
                </span>
              </div>
              <div data-id="element-40">
                <strong className="block font-playfair text-[1.7rem] text-dorado-claro" data-id="element-41">
                  15+
                </strong>
                <span className="text-[.77rem] text-gris-texto uppercase tracking-[.08em]" data-id="element-42">
                  Años investigando
                </span>
              </div>
              <div data-id="element-43">
                <strong className="block font-playfair text-[1.7rem] text-dorado-claro" data-id="element-44">
                  12
                </strong>
                <span className="text-[.77rem] text-gris-texto uppercase tracking-[.08em]" data-id="element-45">
                  Capítulos con evidencia
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}